import { forwardRef } from "react";

/** Format US numbers as (000) 000-0000 while typing; leaves international (+xx) numbers alone. */
export function formatPhone(raw) {
  const s = String(raw || "");
  if (s.trim().startsWith("+") && !s.trim().startsWith("+1")) return s.replace(/[^\d+\s()-]/g, "");
  let d = s.replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  d = d.slice(0, 10);
  if (d.length === 0) return "";
  if (d.length < 4) return d.length === 3 && s.endsWith(")") ? `(${d})` : `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/** Controlled phone input: value is kept formatted. Accepts every normal <input> prop. */
export const PhoneInput = forwardRef(function PhoneInput({ value, onChange, ...rest }, ref) {
  return (
    <input ref={ref} type="tel" inputMode="tel" autoComplete="tel" maxLength={rest.maxLength || 20} {...rest} value={value || ""}
      onChange={(e) => {
        const raw = e.target.value;
        const next = raw.length < String(value || "").length && /\D$/.test(String(value || "")) && !/\d$/.test(raw) ? raw.replace(/\D+$/, "") : raw;
        onChange(formatPhone(next));
      }} />
  );
});
